module.exports = __webpack_public_path__ + "static/img/ccasd.0864c42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ccasd.jpg
// module id = 7YXw
// module chunks = 1